export const isAdminRole = (role) => role === 'admin' || role === 'superadmin';

export const adminLandingPath = (user) => (
  user?.mustChangePassword ? '/admin/change-password' : '/admin'
);

export const adminAccessRedirect = ({ token, user, role, passwordScreen = false }) => {
  if (!token || !isAdminRole(role || user?.role)) return '/';
  if (passwordScreen) return user?.mustChangePassword ? null : '/admin';
  return user?.mustChangePassword ? '/admin/change-password' : null;
};

export const validateAdminPasswordChange = ({ currentPassword, newPassword, confirmPassword }) => {
  if (!currentPassword) return 'Enter your temporary password.';
  if (!newPassword || newPassword.length < 12) return 'Your new password must be at least 12 characters.';
  if (newPassword === currentPassword) return 'Your new password must be different from the temporary password.';
  if (newPassword !== confirmPassword) return 'The new passwords do not match.';
  return '';
};
